<template>
  <CustomUpdateDialog
    :dialogTitle="`افزودن کاربر به مسابقه ${matchTitle}`"
    dialogId="add-user-to-match-dialog"
    :isOkDisabled="isOkButtonDisabled"
    okTitle="افزودن"
    @ok="sendAddUserToMatchRequest"
  >
    <BCol cols="12">
      <StudentPicker
        isInDialog
        @getStudentUserId="setStudentUserId"
      ></StudentPicker>
    </BCol>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    selectedMatch: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      addUserToMatchPayload: {
        matchId: null,
        userId: null,
      },
    };
  },
  methods: {
    setStudentUserId(studentUserId) {
      this.addUserToMatchPayload.userId = studentUserId;
      if (this.selectedMatch && this.selectedMatch.id) {
        this.addUserToMatchPayload.matchId = this.selectedMatch.id;
      }
    },
    async sendAddUserToMatchRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let addUserToMatch = new AddUserToMatch(_this);
        addUserToMatch.setRequestParamDataObj(_this.addUserToMatchPayload);
        await addUserToMatch.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کاربر با موفقیت به مسابقه افزوده شد.",
              },
            });
            _this.addUserToMatchPayload = {
              matchId: null,
              userId: null,
            };
            this.$bvModal.hide("add-user-to-match-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    matchTitle() {
      if (this.selectedMatch && this.selectedMatch.title) {
        return this.selectedMatch.title;
      }
      return "";
    },
    isOkButtonDisabled() {
      if (
        this.selectedMatch &&
        this.selectedMatch.id &&
        this.addUserToMatchPayload.userId &&
        !this.isLoading
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    CustomUpdateDialog,
    StudentPicker,
    TextInput,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import StudentPicker from "@/views/components/Students/StudentPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { AddUserToMatch } from "@/libs/Api/Matches";
import { BCol } from "bootstrap-vue";
</script>
<style scoped></style>
